export default __webpack_public_path__ + "static/db9d12c7dd6e4553fe52987d4e180689.jpg";